import { useState } from 'react';
import { CircularProgress, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import _ from 'lodash';
import { ItemListResponse, ISCAutocompleteResponse } from 'helpers/interfaces';


interface IProps {
    doSearch: (value: string, etag: number) => Promise<ItemListResponse<ISCAutocompleteResponse<any>> | undefined>,
    onChange: (value: ISCAutocompleteResponse<any> | ISCAutocompleteResponse<any>[] | null) => void,
    value: ISCAutocompleteResponse<any>,
    size?: "medium" | "small"
    variant?: "standard" | "filled" | "outlined"
    inputLabel?: string
    multiple?: boolean
    error?: boolean
    helperText?: string
}

let SCAutocomplete = (props: IProps) => {
    let [isLoading, setLoading] = useState(false);
    let [open, setOpen] = useState(false);
    let [options, setOptions] = useState<ISCAutocompleteResponse<any>[]>([]);
    let [etag, setEtag] = useState(0);

    let startSearch = _.debounce(async (e: any, searchTerm: string, reason: string) => {
        if (reason === "input")
            await doSearch(searchTerm)
    }, 500);

    let doSearch = async (searchTerm: string) => {
        setLoading(true)

        setEtag(etag + 1);

        let response = await props.doSearch(searchTerm, etag);

        if (response && response.etag === etag) {
            setOptions(response.items);
        }

        setOpen(true);
        setLoading(false);
    }

    let onChangeText = (value: ISCAutocompleteResponse<any> | ISCAutocompleteResponse<any>[] | null) => {
        props.onChange(value)
    }



    return (
        <Autocomplete
            size={props.size}
            options={options}
            value={props.value.value ? props.value : null}
            loading={isLoading}
            clearOnEscape
            open={open}
            multiple={props.multiple === true}
            onClose={() => {
                setOpen(false);
                setOptions([]);
            }}
            onInputChange={startSearch}
            noOptionsText="No results found"
            filterOptions={options => options}
            onChange={(e, value) => onChangeText(value)}
            getOptionLabel={option => option?.label || ""}
            renderOption={(option: ISCAutocompleteResponse<any>, { inputValue }) => {
                let matches = match(option.label, inputValue);
                let parts = parse(option.label, matches);

                return (
                    <div>
                        {parts.map((part: any, index: number) => (
                            <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                            </span>
                        ))}
                    </div>
                )
            }}
            renderInput={params => (
                <TextField
                    {...params}
                    label={props.inputLabel ? props.inputLabel : ""}
                    variant={props.variant}
                    size={props.size}
                    error={props.error}
                    helperText={props.helperText}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: isLoading && <CircularProgress color="inherit" size={20} />
                    }}
                />
            )}
        />
    );
};

export default SCAutocomplete;